import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import Select from "react-select";

export default function FilterModal({
  show,
  onHide,

  applyFilters,
  removeFilters,

  employeeFilter,
  setEmployeeFilter,

  categoryFilter,
  setCategoryFilter,

  hubFilter,
  setHubFilter,

  vehicleFilter,
  setVehicleFilter,

  vehicles,

  startDate,
  setStartDate,

  endDate,
  setEndDate,

  employees,
  categories,
  hubs,
}) {
  const [tempEmployee, setTempEmployee] = useState(employeeFilter);
  const [tempCategory, setTempCategory] = useState(categoryFilter);
  const [tempHub, setTempHub] = useState(hubFilter);
  const [tempVehicle, setTempVehicle] = useState(vehicleFilter);
  const [tempStartDate, setTempStartDate] = useState(startDate);
  const [tempEndDate, setTempEndDate] = useState(endDate);

  useEffect(() => {
    if (show) {
      setTempEmployee(employeeFilter);
      setTempCategory(categoryFilter);
      setTempHub(hubFilter);
      setTempVehicle(vehicleFilter);
      setTempStartDate(startDate);
      setTempEndDate(endDate);
    }
  }, [
    show,
    employeeFilter,
    categoryFilter,
    hubFilter,
    vehicleFilter,
    startDate,
    endDate,
  ]);

  const handleApply = () => {
    setEmployeeFilter(tempEmployee);
    setCategoryFilter(tempCategory);
    setHubFilter(tempHub);
    setVehicleFilter(tempVehicle);
    setStartDate(tempStartDate);
    setEndDate(tempEndDate);

    applyFilters();
  };

  // Employee options
  const employeeOptions = employees.map((employee) => ({
    value: employee.name,
    label: employee.name,
  }));

  // Vehicle options
  const vehicleOptions = vehicles.map((vehicle) => ({
    value: vehicle.numberplate,
    label: vehicle.numberplate,
  }));

  // Category options
  const categoryOptions = categories.map((category) => ({
    value: category.name,
    label: category.name,
  }));

  // Hub options
  const hubOptions = hubs.map((hub) => ({
    value: hub.name,
    label: hub.name,
  }));

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Filter Options</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          {/* Employee */}
          <Form.Group className="mb-3">
            <Form.Label>User / Employee</Form.Label>

            <Select
              options={employeeOptions}
              value={
                employeeOptions.find(
                  (option) => option.value === tempEmployee,
                ) || null
              }
              onChange={(selectedOption) =>
                setTempEmployee(selectedOption?.value || "")
              }
              placeholder="Search Employee..."
              isClearable
              isSearchable
            />
          </Form.Group>

          {/* Vehicle Number */}
          <Form.Group className="mb-3">
            <Form.Label>Vehicle Number</Form.Label>

            <Select
              options={vehicleOptions}
              value={
                vehicleOptions.find((option) => option.value === tempVehicle) ||
                null
              }
              onChange={(selectedOption) =>
                setTempVehicle(selectedOption?.value || "")
              }
              placeholder="Search Vehicle Number..."
              isClearable
              isSearchable
            />
          </Form.Group>

          {/* Category */}
          <Form.Group className="mb-3">
            <Form.Label>Category</Form.Label>

            <Select
              options={categoryOptions}
              value={
                categoryOptions.find(
                  (option) => option.value === tempCategory,
                ) || null
              }
              onChange={(selectedOption) =>
                setTempCategory(selectedOption?.value || "")
              }
              placeholder="Search Category..."
              isClearable
              isSearchable
            />
          </Form.Group>

          {/* Hub */}
          <Form.Group className="mb-3">
            <Form.Label>Hub</Form.Label>

            <Select
              options={hubOptions}
              value={
                hubOptions.find((option) => option.value === tempHub) || null
              }
              onChange={(selectedOption) =>
                setTempHub(selectedOption?.value || "")
              }
              placeholder="Search Hub..."
              isClearable
              isSearchable
            />
          </Form.Group>

          {/* From Date */}
          <Form.Group className="mb-3">
            <Form.Label>From Date</Form.Label>

            <Form.Control
              type="date"
              value={tempStartDate}
              onChange={(e) => setTempStartDate(e.target.value)}
            />
          </Form.Group>

          {/* To Date */}
          <Form.Group className="mb-3">
            <Form.Label>To Date</Form.Label>

            <Form.Control
              type="date"
              value={tempEndDate}
              onChange={(e) => setTempEndDate(e.target.value)}
            />
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={removeFilters}>
          Remove Filters
        </Button>

        <Button variant="primary" onClick={handleApply}>
          Apply Filters
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
